<template>
  <div v-if="product && activeStep == 3">
    <div class="row">
      <!-- Image -->
      <div class="col-12 col-lg-5 text-center">
        <img
          :src="product.image_url"
          class="img-fluid mt-5"
          style="max-height:20em;"
          :onerror="imgError">
      </div>
      <!-- ProductDetail -->
      <div class="col-12 col-lg-7 mt-5">
        <h5>
          {{ product.description }}
        </h5>
        <p
          v-if="generalInfo"
          class="mt-2">{{ generalInfo.value }}</p>
        <!-- Bullets -->
        <ul
          v-if="bullets"
          class="mt-2">
          <li v-for="b in bullets">
            {{ b.value }}
          </li>
        </ul>
        <div class="mt-3">
          <ProductPrice
            :product="product"
            :dropship="true"
            class="float-start"/>
          <div
            class="float-end"
            style="font-size: 12px; margin-top: 10px;">
            UPC: {{ product.upc }}
          </div>
          <QtyForm
            :product="product"
            :dropship="true"
            :dropshipMfg="mfg"/>
        </div>
      </div>
      <div
        v-if="specs.length"
        class="col-12">
        <div class="float-end">
          <span
            class="text-muted"
            style="cursor: pointer;"
            @click="toggleSeeMore">
              See {{ seeMore ? 'Less' : 'More' }}
              <i
                class="fa"
                :class="seeMore ? 'fa-caret-up' : 'fa-caret-down'"/>
          </span>
        </div>
      </div>
      <div
        v-if="seeMore && specs.length"
        class="col-12 animate__animated animate__fadeIn animate__faster">
        <table class="table table-sm table-bordered mt-2">
          <tbody>
            <tr v-for="s in specs">
              <td class="text-muted">{{ s.description }}</td>
              <td class="text-muted">{{ s.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { ref, computed } from 'vue';
  import ProductPrice from '../../../product/price/ProductPrice.vue';
  import QtyForm from '../../../product/QtyForm.vue';
  import comingSoon from '../../../.././../../shared/comingSoon';
  
  // Initialize
  const store = useStore()
  const seeMore = ref(false)

  // Methods
  const toggleSeeMore = ()=>{
    seeMore.value = !seeMore.value
  }

  const imgError = (e)=>{
    comingSoon(e)
  }

  /* Computed */
  
  // Active Product
  const product = computed(()=>{
    return store.getters.dropshipActiveProduct
  })

  // Active Mfg
  const mfg = computed(()=>{
    return store.getters.dropshipMfg
  })

  // Product Bullets
  const bullets = computed(()=>{
    if(product.value){
      return _.filter(product.value.eclipse_data.specs, s=> s.description.includes('Bullet'))
    }
    return null
  })

  // General Information 
  const generalInfo = computed(()=>{
    if(product.value){
      return _.find(product.value.eclipse_data.specs, s=> s.description.includes('General'))
    }
    return null
  })

  // All other details with bullet removed
  const specs = computed(()=>{
    if(product.value){
      const data = _.filter(product.value.eclipse_data.specs, s=> !s.description.includes('Bullet') && !s.description.includes('General')) 
      return _.orderBy(data, s=> s.description)
    }
    return null
  })

  const activeStep = computed(()=>{
    return store.getters.dropshipStep
  })
</script>